import React from "react";
import { Utensils, Mic, Baby, Flag, Gift, ShoppingBag } from "lucide-react";
import { FEATURES } from "../lib/data";

const ICONS = { utensils: Utensils, mic: Mic, baby: Baby, flag: Flag, gift: Gift, "shopping-bag": ShoppingBag };

const StampCard = ({ f, i }) => {
  const Icon = ICONS[f.icon];
  return (
    <div className="stamp p-3 hover:-translate-y-1.5 transition-transform duration-300" data-testid={`feature-card-${f.key}`}>
      <div className="stamp-inner p-4 h-full flex flex-col">
        <div className="relative overflow-hidden border border-gold/60 mb-4">
          <img src={f.img} alt={f.title} loading="lazy" className="w-full h-40 object-cover sepia-[0.15] saturate-[0.9]" />
          <div className="absolute inset-0 bg-forest/15 mix-blend-multiply" />
          <div className="absolute top-2 right-2 bg-cream border border-forest w-9 h-9 flex items-center justify-center">
            <Icon size={18} className="text-forest" />
          </div>
        </div>
        <h3 className="font-display font-bold text-forest text-xl md:text-2xl leading-tight mb-2">{f.title}</h3>
        <p className="text-forest-light/90 text-[0.95rem] md:text-base leading-relaxed">{f.blurb}</p>
        <div className="dashed-divider my-3" />
        <span className="eyebrow text-rust text-[0.6rem]">Pak Fest · Winnipeg</span>
      </div>
    </div>
  );
};

export const Features = () => (
  <section className="bg-cream-muted py-20 md:py-28" data-testid="features-section">
    <div className="max-w-7xl mx-auto px-4 md:px-8">
      <div className="text-center mb-14 max-w-3xl mx-auto">
        <p className="eyebrow text-rust mb-3">A Full Evening Of Celebration</p>
        <h2 className="font-display font-extrabold text-forest text-4xl sm:text-5xl md:text-6xl mb-5 tracking-tight">
          One Park, A Whole Culture
        </h2>
        <p className="tagline-italic text-forest-light text-2xl md:text-3xl">
          Bring the family, come hungry, and celebrate Pakistan under the Winnipeg sky.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
        {FEATURES.map((f, i) => <StampCard key={f.key} f={f} i={i} />)}
      </div>
    </div>
  </section>
);
